export default __webpack_public_path__ + "static/DF_2015-b22136ce57472ef7ccf9b23869d716dc.pdf";